import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { sendMail, editMail } from '@/api/gmtool/packageCode';
import { gmTool } from "@/mixins/index";
import uploadImagetow from "@/components/uploadImagetow";
export default {
  mixins: [gmTool],
  components: {
    uploadImagetow: uploadImagetow
  },
  props: {
    serverList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    prod: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    channellAllList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this = this,
        _rules;

    var validatePass = function validatePass(rule, value, callback) {
      if (value == '' || value < 0 || value > 65535) {
        callback(new Error(_this.$t('pleaseInputCorrectNumber')));
      } else {
        callback();
      }
    };

    var validateuids = function validateuids(rule, value, callback) {
      var regex = /[\u4e00-\u9fa5，]/;

      if (regex.test(value) || !value) {
        callback(new Error(_this.$t('roleIdIncorrect')));
      } else {
        callback();
      }
    };

    return {
      titleName: "",
      delayList: [{
        label: this.$t('yes'),
        value: 1
      }, {
        label: this.$t('no'),
        value: 2
      }],
      paramsData: {
        title: [],
        content: [],
        template_type: 0,
        is_default: [],
        language: [],
        server_ids: [],
        reward: [],
        content_Val: [],
        type: 'all_role',
        role_ids: '',
        is_delay: 2,
        delay_time: '',
        is_recycle_mail: 2,
        level: {
          minlevel: '',
          maxlevel: ''
        },
        sdk_type: '',
        vip_level: {
          minviplevel: '',
          maxviplevel: ''
        },
        logout_time: {
          minlogouttime: '',
          maxlogouttime: ''
        },
        channel_list: []
      },
      isTemplate: 0,
      date: [],
      dialogShow: false,
      reqLoading: false,
      whetherNot: [{
        label: this.$t('allPlayers'),
        value: 'all_role'
      }, {
        label: this.$t('onlinePlayers'),
        value: 'online_role'
      }, {
        label: this.$t('selectedPlayers'),
        value: 'list_role'
      }, {
        label: this.$t('conditionList'),
        value: 'limit'
      }],
      channelList: [],
      channelChecked: false,
      rules: (_rules = {
        role_ids: [{
          required: true,
          validator: validateuids,
          trigger: "blur"
        }],
        title: [{
          required: true,
          message: this.$t('pleaseInputTitle'),
          trigger: "blur"
        }],
        server_ids: [{
          required: true,
          message: this.$t('pleaseSelectServer'),
          trigger: "blur"
        }],
        sdk_type: [{
          validator: validatePass,
          required: true,
          trigger: "blur"
        }],
        content: [{
          required: true,
          message: this.$t('pleaseInputContent'),
          trigger: "blur"
        }],
        minlevel: [{
          required: true,
          message: this.$t('pleaseInputLevelMin'),
          trigger: "blur"
        }],
        maxlevel: [{
          required: true,
          message: this.$t('pleaseInputLevelMax'),
          trigger: "blur"
        }],
        minviplevel: [{
          required: true,
          message: this.$t('pleaseInputVipMin'),
          trigger: "blur"
        }],
        maxviplevel: [{
          required: true,
          message: this.$t('pleaseInputVipMax'),
          trigger: "blur"
        }],
        minlogouttime: [{
          required: true,
          message: this.$t('pleaseSelectTimeMin'),
          trigger: "blur"
        }],
        maxlogouttime: [{
          required: true,
          message: this.$t('pleaseSelectTimeMax'),
          trigger: "blur"
        }],
        item_id: [{
          required: true,
          message: this.$t('pleaseSelectItem'),
          trigger: "blur"
        }],
        expire_time: [{
          required: true,
          message: this.$t('pleaseSelectExpireTime'),
          trigger: "blur"
        }],
        item_num: [{
          required: true,
          message: this.$t('pleaseInputQuantity'),
          trigger: "blur"
        }],
        is_default: [{
          required: true,
          message: this.$t('pleaseSelectIsTemplate'),
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: this.$t('pleaseSelectLanguage'),
          trigger: "blur"
        }]
      }, _defineProperty(_rules, "content", [{
        required: true,
        message: this.$t('pleaseInputEmailContent'),
        trigger: "blur"
      }]), _defineProperty(_rules, "content_Val", [{
        required: true,
        message: this.$t('pleaseAddContent'),
        trigger: "blur"
      }]), _defineProperty(_rules, "delay_time", [{
        required: true,
        message: this.$t('pleaseSelectScheduledTime'),
        trigger: "blur"
      }]), _defineProperty(_rules, "is_delay", [{
        required: true,
        message: this.$t('pleaseChoose'),
        trigger: "blur"
      }]), _rules),
      isshot: false,
      isMobile: false
    };
  },
  created: function created() {
    this.checkMobile();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    selectAllChannels: function selectAllChannels(val) {
      if (val) {
        // 提取所有渠道的 channel_mark
        this.paramsData.channel_list = this.channellAllList.map(function (item) {
          return item.channel_mark;
        });
      } else {
        this.paramsData.channel_list = [];
      }
    },
    // 2. 下拉框选择项发生变化时触发（用于反向联动勾选/取消全选状态）
    handleChannelChange: function handleChannelChange(val) {
      if (val && val.length === this.channellAllList.length && this.channellAllList.length > 0) {
        this.channelChecked = true;
      } else {
        this.channelChecked = false;
      }
    },
    handleResize: function handleResize() {
      this.checkMobile();
    },
    addtag: function addtag(data, index) {
      this.paramsData.content_Val[index].content = "".concat(this.paramsData.content_Val[index].content).concat(data);
    },
    fileUp: function fileUp(e) {
      console.log("e==", e);
      this.paramsData.role_ids = e.data.toString();
    },
    open: function open(datas, type) {
      var _this2 = this;

      console.log("datas===", datas);

      if (this.isMobile) {
        setTimeout(function () {
          var dialogs = document.querySelectorAll('.dialogs');
          dialogs.forEach(function (dialog) {
            dialog.style.paddingTop = '0';
            dialog.style.paddingBottom = '0';
          });
        }, 100);
      }

      var data = datas ? JSON.parse(JSON.stringify(datas)) : datas;
      this.dialogShow = true;

      if (data && !type) {
        var range = JSON.stringify(data.range) != '[]' ? data.range : data.request_data[0].target.range || '';
        data.reward.map(function (i) {
          //i.type_id = i.type_id.toString();
          var rawId = i.type_id.toString();

          var isExist = _this2.articleList.some(function (item) {
            return item.id.toString() == rawId;
          });

          if (isExist) {
            // 1. 如果存在：赋值给下拉框，手写框留空
            i.type_id = rawId;

            _this2.$set(i, 'custom_input', '');
          } else {
            // 2. 如果不存在：说明是用户手写的，下拉框留空，赋值给手写输入框
            i.type_id = '';

            _this2.$set(i, 'custom_input', rawId);
          } // i.expire = this.$times.timestampToTime(i.expire,"YY-MM-DD H")


          i.ispermanent = i.expire == 0 ? true : false;
        });
        var server_ids = data.server_ids.map(function (i) {
          return Number(i);
        });
        var d = {
          id: data.id,
          title: [],
          content: [],
          is_default: [],
          language: [],
          is_delay: data.is_delay,
          delay_time: data.delay_time ? data.delay_time : '',
          server_ids: server_ids,
          reward: data.reward,
          template_type: data.template_type,
          type: data.player_type,
          role_ids: data.args.length ? data.args.toString() : '',
          level: range.level || this.paramsData.level,
          sdk_type: range.sdktype,
          channel_list: range.channel_list ? range.channel_list.split(',') : [],
          vip_level: range.viplevel || this.paramsData.vip_level,
          content_Val: data.content_Val,
          is_list_role: data.is_list_role,
          logout_time: range.logouttime ? {
            minlogouttime: range.logouttime.minlogouttime,
            maxlogouttime: range.logouttime.maxlogouttime
          } : {
            minlogouttime: '',
            maxlogouttime: ''
          }
        };
        this.isTemplate = data.content_Val[0].is_default;
        this.paramsData = _objectSpread({}, d);

        if (Array.isArray(this.paramsData.channel_list) && this.channellAllList.length > 0 && this.paramsData.channel_list.length === this.channellAllList.length) {
          this.channelChecked = true;
        } else {
          this.channelChecked = false;
        }
      }

      if (type) {
        this.isshot = true;
        this.paramsData.type = "list_role";
        this.paramsData.server_ids = [parseInt(data.server_id)];
        this.paramsData.role_ids = data.role_id;
      }

      this.changeSelect(this.paramsData.server_ids);
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    selectAll: function selectAll() {
      if (this.paramsData.server_ids.length < this.serverList.length) {
        var server_ids = [];
        this.serverList.map(function (item) {
          server_ids.push(item.serverID);
        });
        server_ids.unshift(this.$t('selectAll'));
        this.paramsData.server_ids = [].concat(server_ids);
      } else {
        // 取消全选
        this.paramsData.server_ids = [];
      }
    },
    changeSelect: function changeSelect(val) {
      var _this3 = this;

      if (!val.includes(this.$t('selectAll')) && val.length === this.serverList.length) {
        this.paramsData.server_ids.unshift(this.$t('selectAll'));
      } else if (val.includes(this.$t('selectAll')) && val.length - 1 < this.serverList.length) {
        this.paramsData.server_ids = this.paramsData.server_ids.filter(function (item) {
          return item !== _this3.$t('selectAll');
        });
      }
    },
    removeTag: function removeTag(val) {
      if (val === this.$t('selectAll')) {
        this.paramsData.server_ids = [];
      }
    },
    addDomain: function addDomain() {
      this.paramsData.reward.push({
        num: '',
        expire: '',
        ispermanent: false,
        type_id: ''
      });
    },
    removeDomain: function removeDomain(item) {
      var index = this.paramsData.reward.indexOf(item);

      if (index !== -1) {
        this.paramsData.reward.splice(index, 1);
      }
    },
    addContent: function addContent() {
      this.paramsData.content_Val.push({
        disabled: false,
        content: '',
        language: '',
        title: '',
        is_default: ''
      });
    },
    removeContent: function removeContent(item) {
      var index = this.paramsData.content_Val.indexOf(item);

      if (index !== -1) {
        this.paramsData.content_Val.splice(index, 1);
      }
    },
    clearData: function clearData(isClearId) {
      var isClearContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.isTemplate = isClearContent ? 0 : this.isTemplate;
      this.paramsData = {
        id: isClearId ? '' : this.paramsData.id,
        title: [],
        content: [],
        is_default: [],
        template_type: isClearContent ? 0 : this.paramsData.template_type,
        language: [],
        server_ids: this.isshot ? this.paramsData.server_ids : [],
        reward: isClearContent ? [] : this.paramsData.reward,
        type: this.paramsData.type,
        is_delay: 2,
        delay_time: '',
        role_ids: this.isshot ? this.paramsData.role_ids : '',
        content_Val: isClearContent ? [] : this.paramsData.content_Val,
        level: {
          minlevel: '',
          maxlevel: ''
        },
        sdk_type: '',
        vip_level: {
          minviplevel: '',
          maxviplevel: ''
        },
        logout_time: {
          minlogouttime: '',
          maxlogouttime: ''
        },
        channel_list: []
      };
      this.channelChecked = false;
      this.$refs.ruleForm.clearValidate();
    },
    dataChange: function dataChange(e) {
      this.paramsData.start_time = e[0] / 1000;
      this.paramsData.end_time = e[1] / 1000;
    },
    isTemplateChange: function isTemplateChange(e) {
      if (e == 0 && this.paramsData.template_type == 1) {
        this.paramsData.content_Val = [];
      }

      this.paramsData.template_type = 0;
    },
    templateTypeChange: function templateTypeChange(e) {
      var _this4 = this;

      this.paramsData.content_Val = [];
      var list = [];

      if (e == 1) {
        list = this.compensationList;
      } else if (e == 2) {
        list = this.awardDistribution;
      }

      list.forEach(function (i) {
        _this4.paramsData.content_Val.push({
          disabled: true,
          content: i.content,
          language: i.value,
          title: i.title,
          is_default: '1'
        });
      });
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this5 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this5.reqLoading = true;
          var data = JSON.parse(JSON.stringify(_this5.paramsData));
          console.log("data===哈哈哈哈", data);

          if (data.type == 'limit') {
            // data.logout_time.minlogouttime = this.$times.timestampToTime(data.logout_time.minlogouttime / 1000, "YY-MM-DD hh:mm:ss")
            data.logout_time.minlogouttime = data.logout_time.minlogouttime; // data.logout_time.maxlogouttime =  this.$times.timestampToTime(data.logout_time.maxlogouttime / 1000, "YY-MM-DD hh:mm:ss")

            data.logout_time.maxlogouttime = data.logout_time.maxlogouttime;
            data.vip_level = data.vip_level.minviplevel || data.vip_level.maxviplevel ? JSON.stringify(data.vip_level) : "";
            data.logout_time = data.logout_time.minlogouttime || data.logout_time.maxlogouttime ? JSON.stringify(data.logout_time) : "";
            data.level = data.level.minlevel || data.level.maxlevel ? JSON.stringify(data.level) : "";
            data.channel_list = data.channel_list.length ? data.channel_list.join(",") : '';
          } else if (data.type == 'list_role') {
            delete data.vip_level;
            delete data.logout_time;
            delete data.level;
            delete data.sdk_type;
          } else {
            delete data.vip_level;
            delete data.logout_time;
            delete data.level;
            delete data.role_ids;
            delete data.sdk_type;
          }

          var newList = [];
          var rewardObj = {};

          if (data.is_list_role == 1) {
            data.reward.forEach(function (item) {
              var roleId = item.role_id;

              if (!rewardObj[roleId]) {
                rewardObj[roleId] = [];
              }

              var finalTargetId = item.type_id ? item.type_id : item.custom_input;
              rewardObj[roleId].push({
                type_id: parseInt(finalTargetId),
                num: parseInt(item.num),
                expire: item.expire || 0
              });
            });
          } else {
            data.reward.forEach(function (item) {
              var finalTargetId = item.type_id ? item.type_id : item.custom_input;
              newList.push({
                type_id: parseInt(finalTargetId),
                expire: item.ispermanent ? 0 : item.expire,
                num: parseInt(item.num)
              });
            });
          }

          if (data.is_list_role == 1) {
            data.reward = JSON.stringify(rewardObj);
          } else {
            data.reward = newList.length ? JSON.stringify(newList) : "";
          }

          data.content_Val.forEach(function (item) {
            data.title.push(item.title);
            data.is_default.push(_this5.isTemplate);
            data.language.push(item.language);
            data.content.push(item.content);
          });
          data.delay_time = data.is_delay == 1 ? data.delay_time : ''; // data.delay_time = data.is_delay == 1 ? data.delay_time / 1000 : ''

          if (data.server_ids.length > _this5.serverList.length) {
            data.server_ids.splice(0, 1);
          }

          var reqFn = _this5.paramsData.id ? editMail : sendMail;
          delete data.content_Val;
          reqFn(_objectSpread(_objectSpread(_objectSpread({}, data), _this5.prod), {}, {
            game_id: _this5.rawData.game_id
          })).then(function (res) {
            if (res.code == 200 || res.status == 200) {
              _this5.reqLoading = false;

              _this5.$message({
                message: _this5.$t('operationSuccess'),
                type: 'success'
              });

              _this5.dialogShow = false;

              _this5.$emit('change');
            }
          }).finally(function () {
            _this5.reqLoading = false;
          });
        }
      });
    }
  }
};